{
  "status": {
    "pending_payment": "支払い待ち",
    "paid": "支払い完了 — 発送準備中",
    "ready_to_ship": "発送準備完了",
    "exported_to_click_drop": "Click & Drop へエクスポート済み",
    "shipped": "発送済み",
    "delivered": "配達完了",
    "released": "支払い済み",
    "refunded": "返金済み",
    "cancelled": "キャンセル済み",
    "disputed": "異議申立て中"
  },
  "disputeStatus": {
    "open": "受付中",
    "awaiting_seller": "出品者の回答待ち",
    "awaiting_buyer": "購入者の回答待ち",
    "under_review": "審査中",
    "resolved_buyer": "解決済み（購入者）",
    "resolved_seller": "解決済み（出品者）",
    "closed": "クローズ"
  },
  "disputeReason": {
    "item_not_received": "商品未着",
    "item_not_as_described": "商品説明と異なる",
    "damaged_item": "商品破損",
    "wrong_item": "誤った商品が届いた",
    "suspected_counterfeit": "偽造品の疑い",
    "missing_contents": "内容物の欠品",
    "tracking_problem": "追跡情報の問題",
    "other": "その他"
  },
  "disputeResolution": {
    "full_refund": "全額返金",
    "partial_refund": "一部返金",
    "replacement": "交換",
    "other": "その他"
  },
  "page": {
    "eyebrow": "注文",
    "title": "ご注文一覧",
    "subtitle": "支払い、発送、支払い処理の状況を確認できます。金額はすべて英ポンド（GBP）表示です。"
  },
  "tabs": {
    "purchases": "購入履歴",
    "sales": "販売履歴",
    "all": "全注文（管理者）"
  },
  "loadError": "注文を読み込めませんでした：{message}",
  "filtered": "絞り込み中：",
  "clearFilter": "絞り込みを解除",
  "purchaseType": {
    "buyNow": "即決購入",
    "auction": "オークション"
  },
  "clickDrop": {
    "banner": "Royal Mail Click & Drop — 支払い済みの注文を選択してCSVをエクスポートし、Click & Drop にアップロードして送料をお支払いください。",
    "howToImport": "インポート方法",
    "exportSelected": "選択した{count}件をCSVでエクスポート"
  },
  "table": {
    "item": "商品",
    "status": "ステータス",
    "type": "種別",
    "payout": "支払額",
    "total": "合計",
    "actions": "操作",
    "loading": "読み込み中…",
    "emptyFiltered": "選択したステータスに該当する注文はありません。",
    "emptyBuyer": "まだ落札したオークションはありません。",
    "emptySeller": "まだ販売した商品はありません。",
    "emptyAdmin": "プラットフォーム上に注文はまだありません。",
    "tracking": "追跡番号：{number}",
    "labelError": "ラベルエラー：{message}",
    "disputeActive": "異議申立て中",
    "payNow": "今すぐ支払う",
    "receiptSeller": "販売インボイス（PDF）",
    "receiptBuyer": "領収書（PDF）",
    "clickDropCsv": "Click & Drop CSV",
    "retryLabel": "Royal Mail ラベルを再試行",
    "buyLabel": "Royal Mail ラベルを購入",
    "downloadLabel": "ラベルをダウンロード／印刷",
    "trackParcel": "荷物を追跡",
    "enterTracking": "追跡番号を入力して発送",
    "confirmDelivery": "配達を確認",
    "reportProblem": "問題を報告",
    "viewDispute": "異議申立てを確認",
    "releasePayout": "支払いを実行",
    "paidOut": "支払い済み"
  },
  "toast": {
    "checkoutError": "決済を開始できませんでした",
    "shippedSuccess": "発送済みにしました — 購入者に通知済みです",
    "invoiceError": "インボイスを開けませんでした",
    "deliveryReleased": "配達を確認しました — 出品者への支払いを実行しました",
    "deliveryProcessing": "配達を確認しました — 支払い処理中です",
    "deliveryConfirmed": "配達を確認しました",
    "deliveryError": "配達を確認できませんでした。もう一度お試しください。",
    "stripeTransferCreated": "Stripe送金を作成しました：{id}",
    "exportedMarked": "エクスポート済みにしました — ラベル印刷後に追跡番号を入力してください",
    "labelDuplicate": "この注文には既にラベルが存在します",
    "labelGenerated": "Royal Mail ラベルを発行しました — 追跡番号を購入者にメール送信しました",
    "labelFailed": "ラベル発行に失敗しました：{message}",
    "labelOpenError": "ラベルを開けませんでした：{message}",
    "missingAddressWarning": "{count}件の注文に配送先住所が登録されていません — 該当行のCSVは空欄になります。",
    "movedUnderReview": "審査中に変更しました",
    "evidenceRequested": "証拠の提出を依頼しました",
    "disputeClosed": "異議申立てをクローズしました",
    "resolvedSeller": "出品者側の主張を認めました — 支払いを実行しました",
    "resolvedBuyer": "返金を実行しました",
    "evidenceUploaded": "証拠をアップロードしました",
    "invalidRefundAmount": "返金額が無効です",
    "disputeResolved": "異議申立てを解決しました",
    "disputeOpened": "異議申立てを送信しました — 管理者が確認します"
  },
  "dialogs": {
    "shipment": {
      "title": "追跡番号を入力して発送済みにする",
      "description": "Royal Mail Click & Drop ラベルに記載の追跡番号を貼り付けてください。保存すると自動的に購入者へメール通知されます。",
      "trackingLabel": "追跡番号",
      "trackingPlaceholder": "例：AB123456789GB",
      "trackingHelp": "必須項目です。Royal Mail ラベルに印字された追跡／参照番号を入力してください。",
      "cancel": "キャンセル",
      "save": "追跡番号を保存して購入者に通知"
    },
    "guide": {
      "title": "Royal Mail Click & Drop — CSVのインポート方法",
      "description": "BidNova Auctions は標準のClick & Dropテンプレート形式で注文をエクスポートするので、数分で送料の支払いが完了します。",
      "step1": "business.parcel.royalmail.com にログインし、「Orders → Import orders」を開きます。",
      "step2": "形式でCSVを選択し、BidNova Auctionsからダウンロードしたファイルをアップロードします。",
      "step3": "項目マッピング画面で、保存済みの「BidNova Auctions」マッピングを選択します（初回アップロード後はClick & Dropが記憶します。ヘッダーは標準テンプレートに準拠しています）。",
      "step4": "インポートされた注文を確認し、発送する項目にチェックを入れて「Apply postage」をクリックします。サービス列には購入者が選択した配送方法が表示されています。",
      "step5": "ラベルを印刷し、郵便局への持ち込みまたは集荷を手配した後、こちらに戻って「追跡番号を入力して発送」をクリックしてください — 購入者へ自動的にメール通知されます。",
      "tip": "ヒント：複数の支払い済み注文をまとめて選択し、1つのCSVとしてエクスポートすると、Click & Dropで一括インポートできます。",
      "gotIt": "了解しました"
    },
    "label": {
      "title": "Royal Mail ラベルを作成",
      "description": "この注文の荷物情報を編集します。デフォルト値は配送設定から取得されます。",
      "lastAttemptFailed": "前回の試行は失敗しました",
      "weight": "重量（グラム）",
      "packageType": "梱包タイプ",
      "packageTypes": {
        "letter": "レター",
        "largeLetter": "ラージレター",
        "smallParcel": "スモールパーセル",
        "mediumParcel": "ミディアムパーセル",
        "parcel": "パーセル"
      },
      "service": "配送サービス",
      "length": "長さ（mm）",
      "width": "幅（mm）",
      "depth": "奥行き（mm）",
      "dimensionsHint": "サイズは任意です — 0のままにすると梱包タイプの標準値が使用されます。",
      "cancel": "キャンセル",
      "retry": "再試行",
      "create": "ラベルを作成"
    },
    "release": {
      "title": "Stripe Connect 経由で支払いを実行",
      "description": "Stripe Connect 経由で出品者に{amount}を支払いますか？",
      "cancel": "キャンセル",
      "releasing": "処理中…",
      "releaseButton": "Stripeで支払いを実行"
    },
    "pay": {
      "title": "配送方法を選択",
      "description": "Royal Mail のサービスを選択してください。送料はStripeでのお支払いに加算されます。",
      "method": "配送方法",
      "item": "商品",
      "shipping": "送料",
      "total": "合計",
      "cancel": "キャンセル",
      "redirecting": "リダイレクト中…",
      "continue": "Stripeへ進む"
    }
  },
  "orderDetail": {
    "status": "注文ステータス",
    "shipment": "配送追跡",
    "trackingNumber": "追跡番号",
    "shippedAt": "発送日時",
    "deliveryConfirmed": "購入者による配達確認",
    "yes": "はい",
    "no": "いいえ",
    "autoDeliverEligibility": "自動配達確認の対象時期",
    "payout": "支払い",
    "saleTotal": "販売合計額",
    "commission": "手数料",
    "sellerPayout": "出品者への支払額",
    "released": "支払い実行日時",
    "notYet": "未実行",
    "stripeTransferId": "Stripe送金ID",
    "disputes": "異議申立て",
    "adminNote": "管理者メモ：{note}",
    "openDisputeCase": "異議申立てを開く",
    "resolveRefundTitle": "購入者へ返金",
    "resolveReleaseTitle": "出品者へ支払いを実行",
    "resolveDismissTitle": "この異議申立てを却下",
    "resolveRefundDesc": "注文を返金済みとしてマークし、異議申立てをクローズします。購入者に通知されます。",
    "resolveReleaseDesc": "異議申立てをクローズします。配達条件を満たせば支払いを実行できます。",
    "resolveDismissDesc": "注文内容を変更せずに異議申立てをクローズします。",
    "resolveNotesLabel": "解決メモ（購入者・出品者双方に共有されます）",
    "resolveNotesPlaceholder": "判断内容を説明し、双方が結果を理解できるようにしてください。",
    "cancel": "キャンセル",
    "confirm": "確定",
    "auditLog": "監査ログ",
    "auditLogAdmin": "（管理者ビュー）",
    "noEvents": "まだイベントはありません。",
    "amount": "金額：{amount}",
    "resumeCheckout": "Stripe決済を再開",
    "viewAuction": "オークションを見る"
  },
  "success": {
    "confirming": "お支払いを確認しています…",
    "confirmingHint": "少々お待ちください — 通常は数秒で完了します。",
    "pendingTitle": "お支払いは処理中です",
    "pendingFallback": "しばらくしてから再度ご確認ください。",
    "pendingStatus": "支払いステータス：{status}",
    "goToOrders": "注文一覧へ",
    "errorTitle": "エラーが発生しました",
    "orderReference": "注文番号：",
    "myOrders": "注文一覧",
    "contactSupport": "サポートに連絡",
    "paidTitle": "お支払いが完了しました",
    "paidSubtitle": "ありがとうございます — 出品者に通知され、まもなくカードが発送されます。",
    "orderReferenceInline": "注文番号 {ref}",
    "yourItem": "ご購入商品",
    "auctionFallback": "オークション",
    "itemLabel": "商品",
    "shippingLabel": "送料",
    "totalPaid": "支払い合計",
    "viewOrder": "注文を確認",
    "continueBrowsing": "閲覧を続ける",
    "receiptEmailed": "領収書とインボイスをメールでお送りしました。"
  },
  "orderCentre": {
    "eyebrow": "購入履歴",
    "title": "オーダーセンター",
    "subtitle": "すべての注文の状況をライフサイクル全体で確認できます。閲覧専用ビューです — お問い合わせは「出品者に連絡」をご利用ください。",
    "tabs": {
      "active": "進行中",
      "waiting_dispatch": "発送待ち",
      "shipped": "発送済み",
      "delivered": "配達完了",
      "cancelled": "キャンセル済み",
      "returned": "返品済み"
    },
    "loading": "読み込み中…",
    "empty": "このカテゴリーには注文がありません。",
    "table": {
      "orderNumber": "注文番号",
      "item": "商品",
      "seller": "出品者",
      "amount": "金額",
      "tracking": "追跡番号",
      "dispatched": "発送日",
      "delivered": "配達日",
      "rmStatus": "RMステータス",
      "actions": "操作"
    },
    "auctionItem": "オークション商品",
    "track": "追跡",
    "invoice": "インボイス",
    "contact": "連絡"
  },
  "disputesList": {
    "eyebrow": "異議申立てセンター",
    "title": "異議申立て一覧",
    "subtitle": "注文に関する異議申立てを確認・対応します。",
    "loadError": "異議申立てを読み込めませんでした：{message}",
    "loading": "読み込み中…",
    "empty": "異議申立てはまだありません。",
    "orderFallback": "注文",
    "openedOn": "#{id} · {date}に開始"
  },
  "disputeDetail": {
    "back": "← 異議申立て一覧",
    "orderFallback": "注文に関する異議申立て",
    "reference": "異議申立て #{disputeId} · 注文 #{orderId}",
    "salePrice": "販売価格：{amount}",
    "shipping": "配送方法：{method}",
    "tracking": "追跡番号：{number}",
    "reason": "理由",
    "requestedResolution": "希望する解決方法",
    "description": "詳細",
    "adminResolution": "管理者による裁定",
    "refund": "返金額：{amount}",
    "conversation": "やり取り",
    "internalNote": "内部メモ",
    "noMessages": "メッセージはまだありません。",
    "messagePlaceholder": "メッセージを入力…",
    "internalNoteCheckbox": "内部管理者メモ（購入者・出品者には非表示）",
    "attachEvidence": "証拠を添付",
    "send": "送信",
    "evidence": "証拠",
    "noEvidence": "証拠はまだアップロードされていません。",
    "open": "開く",
    "evidenceMeta": "{role} · {name} · {size} KB",
    "adminActions": "管理者操作",
    "askBuyerEvidence": "購入者に追加証拠を求める",
    "askSellerEvidence": "出品者に追加証拠を求める",
    "moveUnderReview": "審査中に変更",
    "closeNoAction": "金銭処理なしでクローズ",
    "resolveSellerFavour": "出品者側の主張を認める（支払い実行）",
    "resolveBuyerFavour": "購入者側の主張を認める（返金）",
    "closeTitle": "金銭処理なしで異議申立てをクローズ",
    "resolveSellerTitle": "出品者側の主張を認める",
    "resolveBuyerTitle": "購入者側の主張を認める（返金）",
    "resolveSellerDesc": "Stripe経由で出品者への支払いを実行します。",
    "resolveBuyerDesc": "以前の出品者への送金を取り消し、購入者へ返金します。",
    "closeDesc": "注文はそのまま進み、返金や送金の変更は行われません。",
    "refundAmountLabel": "返金額（GBP）— 空欄の場合は{amount}を全額返金します",
    "resolutionNotesLabel": "解決メモ（必須、5文字以上）",
    "cancel": "キャンセル",
    "confirm": "確定",
    "closedNotice": "異議申立てはクローズされました。",
    "loading": "読み込み中…"
  },
  "timeline": {
    "ariaLabel": "注文ステータスのタイムライン",
    "placed": "注文完了",
    "paid": "支払い確認済み",
    "preparing": "出品者が準備中",
    "preparingHint": "出品者の発送待ちです",
    "dispatched": "発送済み",
    "inTransit": "配送中",
    "inTransitHint": "追跡番号 {number}",
    "delivered": "配達完了",
    "completed": "完了",
    "issueReported": "問題が報告されました",
    "issueHint": "サポートがこの注文を確認しています",
    "inProgress": "進行中"
  },
  "disputeDialog": {
    "title": "問題を報告",
    "description": "異議申立てを行うと、管理者が確認するまで出品者への支払いが保留されます。",
    "orderLabel": "注文：{title}",
    "reasonLabel": "理由",
    "reasonPlaceholder": "理由を選択してください",
    "resolutionLabel": "ご希望の対応は？",
    "resolutionPlaceholder": "解決方法を選択してください",
    "descriptionLabel": "問題の詳細",
    "descriptionPlaceholder": "発生した内容をご説明ください（10文字以上）。送信後、異議申立てページで写真を添付できます。",
    "charCount": "{count}/4000文字",
    "confirmCheckbox": "正式な異議申立てを行い、出品者への支払いが保留されることを理解しました。",
    "cancel": "キャンセル",
    "submit": "異議申立てを送信"
  }
}